import React from "react";
import { Box, Typography } from "@mui/material";
import "./index.scss";
import { Images } from "../../assets/common";

export default function ProfileMenu({
  actions,
  handleProfileMenuChoice,
  isLast,
  color,
  isHeader,
  right,
  fixedPos,
}) {
  const posStyle = fixedPos
    ? { position: "fixed", top: fixedPos.top, left: fixedPos.left ?? "auto", right: fixedPos.right ?? "auto" }
    : { position: "absolute", top: isLast ? isLast : "initial", right: right ? right : "initial" };
  return (
    <Box
      className="__music_card_menu"
      sx={{
        ...posStyle,
        display: "flex",
        flexDirection: "column",
        gap: "6px",
        zIndex: 9999,
      }}
    >
      {actions.map(({ action, key }, index) =>
        key === "divider" ? (
          <Box
            key={index}
            sx={{
              height: "1px",
              backgroundColor: "#D5D5D5",
              width: "100%",
            }}
          />
        ) : action ? (
          isHeader ? (
            <Box
              key={index}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                padding: "6px 0",
                cursor: "pointer",
                width: "100%",
              }}
            >
              <img
                style={{ width: "18px", height: "18px", objectFit: "contain", display: "block" }}
                src={
                  key === "m11"
                    ? Images.settings_icon
                    : key === "m13"
                    ? Images.logout
                    : key === "m14"
                    ? Images.notification // Using notification icon for Feedback Hub
                    : key === "m15"
                    ? Images.copy
                    : key === "m16"
                    ? Images.facebook
                    : key === "m17"
                    ? Images.twitter_t
                    : key === "m18"
                    ? Images.privacy_policy
                    : key === "m19"
                    ? Images.terms_service
                    : key === "m20"
                    ? Images.how_to_use
                    : key === "m21"
                    ? Images.user_black
                    : key === "m22"
                    ? Images.how_to_use // Using how_to_use icon for Customer Journey
                    : "null"
                }
                alt=""
              />
              <Typography
                className="_cp"
                color={color ? color : "black"}
                key={index}
                onClick={(e) => {
                  e.stopPropagation();
                  handleProfileMenuChoice(key);
                }}
                sx={{
                  fontSize: "16px",
                  lineHeight: "20px",
                  opacity: 1,
                }}
              >
                {action}
              </Typography>
            </Box>
          ) : (
            <Typography
              className="__music_card_menu_item _cp"
              color={color ? color : "initial"}
              key={index}
              onClick={(e) => {
                e.stopPropagation();
                handleProfileMenuChoice(key);
              }}
            >
              {action}
            </Typography>
          )
        ) : null
      )}
    </Box>
  );
}
